import { ArrowUpRight } from 'lucide-react'
import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'

import { useState } from 'react'
import AccordionServicos from './accordionServicos'
import BadgetOtimize from './badget-otimize'
import CardServicos from './cardServicos'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from './carousel'
import Container from './container'

export default function SolucoesDesenvolvimento() {
  const { openModal } = useModal()
  const [openAccordionId, setOpenAccordionId] = useState(null)
  const servicosData = [
    {
      id: 1,
      icon: '../assets/gestao-icone.png',
      iconHover: '../assets/gestao-icone.png',
      title: 'Aplicativos móveis',
      text: 'Nossas soluções de desenvolvimento de aplicativos se adaptam às suas necessidades: utilizamos tecnologias nativas ou híbridas, e aplicamos métodos ágeis para testar seu modelo de negócio rapidamente. À medida que suas demandas evoluem, aprimoramos a arquitetura das soluções para ampliar a  robustez.',
      glowColor: '#A800E4',
      url: '',
    },
    {
      id: 2,
      icon: '../assets/icone-suporte.png',
      iconHover: '../assets/icone-suporte.png',
      title: 'Plataformas, SaaS, APIs',
      text: 'Desenvolvemos plataformas escaláveis e de alto desempenho, otimizadas para serviços em nuvem, assegurando que sua infraestrutura atenda a demandas elevadas e suporte o crescimento futuro.',
      glowColor: '#A800E4',
      url: '',
    },
    {
      id: 3,
      icon: '../assets/icone-risco.png',
      iconHover: '../assets/icone-risco.png',
      title: 'Softwares sob medida',
      text: 'Soluções personalizadas para automatizar processos, transformando serviços manuais em digitais, aprimorando a gestão, aumentando as vendas e integrando softwares de terceiros de forma eficiente.',
      glowColor: '#A800E4',
      url: '',
    },
    {
      id: 4,
      icon: '../assets/gestao-icone.png',
      iconHover: '../assets/gestao-icone.png',
      title: 'RPA',
      text: 'Soluções sob medida para automatizar processos, transformar serviços manuais em digitais, aprimorar a gestão, aumentar as vendas e integrar softwares de terceiros de forma eficiente.',
      glowColor: '#A800E4',
      url: '',
    },
  ]

  return (
    <section className="bg-[#0F083A] md:min-h-screen py-16 text-white overflow-hidden relative">
      <Container className="space-y-9 relative z-10">
        <header className="grid grid-cols-1 xl:grid-cols-2 items-center gap-6 md:gap-0">
          <div className="space-y-12">
            <h2 className="text-3xl text-center md:text-left lg:text-6xl font-inter-regular">
              Soluções em{' '}
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#A800E4] via-[#D700E2] via-[#FB00C7] via-[#FF00A0] to-[#FF1B76]">
                desenvolvimento
              </span>
            </h2>
          </div>
          <div>
            <p className="font-inter-regular text-xs text-center md:text-left md:text-2xl">
              Desenvolvemos as melhores soluções, a partir do entendimento das
              necessidades do seu negócio.
            </p>
          </div>
        </header>
        <div className="hidden md:block relative ps-[2px] py-[2px] pe-px rounded-[30px] bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] w-fit">
          <div className="flex items-center gap-8 bg-[#2B283D] px-6 py-3.5 rounded-[30px] text-white">
            <h3 className="w-fit font-inter-light">
              Otimize seu <br /> negócio!
            </h3>
            <button
              type="button"
              onClick={() => openModal(<FormularioRD />)}
              className="w-fit bg-white text-black text-sm font-inter-light flex items-center gap-2 py-1 px-10 rounded-full cursor-pointer hover:scale-105 transition-all duration-300"
            >
              Contratar <ArrowUpRight className="size-5" />
            </button>
          </div>
        </div>
        <main className="overflow-visible">
          <Carousel className="w-full hidden md:block">
            <CarouselContent className="-mt-16 py-16 gap-0">
              {servicosData.map((servico, index) => (
                <CarouselItem
                  key={index}
                  className="basis-full sm:basis-1/2 md:basis-1/3"
                >
                  <div className="">
                    <CardServicos {...servico} height={450} />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex justify-end absolute right-20 bottom-20 z-10">
              <CarouselPrevious className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
              <CarouselNext className="h-8 w-8 rounded-full bg-transparent hover:cursor-pointer hover:scale-130 transition-transform duration-300" />
            </div>
          </Carousel>

          <div className="md:hidden space-y-3">
            {servicosData.map((card, index) => (
              <div key={index} className="space-y-4">
                <button
                  type="button"
                  onClick={() =>
                    setOpenAccordionId(
                      openAccordionId === card.id ? null : card.id,
                    )
                  }
                  className="w-full"
                >
                  <AccordionServicos
                    {...card}
                    className="bg-[rgb(36,29,73)] backdrop-blur-[92px]"
                    doesThereButton={false}
                  />
                </button>
                {openAccordionId === card.id && <BadgetOtimize />}
              </div>
            ))}
          </div>
        </main>
      </Container>
      <img
        src="../assets/gradiente.png"
        alt=""
        className="hidden md:block w-full absolute left-0 bottom-0 object-cover z-0 h-fit"
      />
    </section>
  )
}
